export default "/images/line.svg?8af92af9b5e3996484a46bef4e7f81bd";